export default "__VITE_ASSET__VpDiOm53i8o_O8vYp_y8kA__"